<template>
  <div class="item-wrapper">
    <div class="desc desc-32 name">{{ item.title }}</div>
    <div class="preview">
      <transition name="fade">
        <span class="title" v-if="addToCartChosenItem == item.id">{{
          $t("Added")
        }}</span>
      </transition>
      <img :src="imgDomain + item.image_url" class="img" />
    </div>
    <div class="left">
      <div class="price desc medium">
        <b>{{ item.price }}</b>
        <img src="./../images/coin2.svg" class="img" />
      </div>
    </div>
    <button
      class="button small rounded w-150"
      @click="$emit('addToCart', item, item.id)"
    >
      {{ $t("Add to cart") }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ProductCard",
  props: ["item", "currency", "addToCartChosenItem"],
  data: function () {
    return {
      imgDomain: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {},
};
</script>
